import { InjectionToken, Provider } from '@angular/core';
import { DefaultThemes } from '../const';
import { ThemeCollection } from '../interfaces';

export const ROUND_BUTTON_THEMES = new InjectionToken<ThemeCollection>('MA_ROUND_BUTTON_THEMES');

export function provideRoundButtonThemes(themes: ThemeCollection): Provider {
  return {
    provide: ROUND_BUTTON_THEMES,
    useValue: {
      ...DefaultThemes,
      ...themes,
    },
  };
}
